"use client";
import { motion, useReducedMotion } from "framer-motion";
import {
  Container,
  CountUpValue,
  SectionSubHeading,
  SectionTitle,
} from "@/components";
import { caseStudyReceipts } from "@/data/CaseStudyPageData";
import { cardRise, cardStagger, fadeInUp } from "@/lib/animation/variant";

const CaseStudyReceipts = () => {
  const reduceMotion = useReducedMotion();

  return (
    <section className="relative isolate mt-16 w-full overflow-hidden rounded-4xl bg-primary py-14 text-accent-foreground md:mt-24 md:py-20">
      {/* Diagonal hatch drifting behind the figures — one band's worth of travel,
          so the loop restarts on an identical stripe and never seams. */}
      <motion.div
        aria-hidden
        style={{
          inset: "-40% -10%",
          background:
            "repeating-linear-gradient(-45deg, color-mix(in srgb, var(--color-accent-foreground) 8%, transparent) 0 22px, transparent 22px 66px)",
        }}
        animate={reduceMotion ? undefined : { x: [0, 88] }}
        transition={{ duration: 24, repeat: Infinity, ease: "linear" }}
        className="pointer-events-none absolute -z-10"
      />

      <Container className="flex flex-col gap-8 px-4 lg:px-10">
        <div className="space-y-2">
          <motion.div
            custom={0}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <SectionSubHeading
              subtitle="The receipts"
              className="text-accent-foreground/70"
            />
          </motion.div>

          <motion.div
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <SectionTitle
              title="Numbers their own analytics still reports."
              className="max-w-[22ch]"
            />
          </motion.div>
        </div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          variants={cardStagger}
          className="grid gap-3.5 md:grid-cols-2 xl:grid-cols-4"
        >
          {caseStudyReceipts.map((receipt) => (
            <motion.div
              key={receipt.label}
              variants={cardRise}
              className="border-2 border-accent-foreground bg-white/60 p-5 transition-[transform,background-color] duration-500 hover:-translate-y-1.5 hover:bg-white md:p-6"
            >
              <p className="text-4xl leading-none font-black tracking-tighter tabular-nums md:text-5xl">
                <CountUpValue value={receipt.value} count={receipt.count} />
              </p>
              <p className="mt-3 font-mono text-[10px] leading-relaxed tracking-[0.15em] text-accent-foreground/75 uppercase">
                {receipt.label}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </Container>
    </section>
  );
};

export default CaseStudyReceipts;
